import React from "react";
import { motion } from "framer-motion";

const HeroStatsBar = ({ stats = [], onStatClick }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4 }}
      className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6"
    >
      {stats.map((stat, index) => (
        <motion.button
          key={stat.id || index}
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: index * 0.1 }}
          whileHover={{ y: -2 }}
          onClick={() => onStatClick?.(stat.id)}
          className="group text-left focus:outline-none bg-white dark:bg-gray-800 rounded-sm border border-gray-200 dark:border-gray-700 shadow-sm dark:shadow-none hover:bg-gray-50 dark:hover:bg-gray-750 p-4 sm:p-5 relative overflow-hidden"
        >
          <div className="h-1 w-8 bg-accent1 absolute top-0 left-0 transition-all duration-300 group-hover:w-full" />
          <div className="text-3xl sm:text-4xl font-black text-accent1 tracking-tight mt-2">
            {stat.value}
          </div>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2">
            {stat.label}
          </div>
        </motion.button>
      ))}
    </motion.div>
  );
};

export default HeroStatsBar;
